export default __webpack_public_path__ + "static/undebtme-overview-screen-b08c797ff79e9d960d951d42cd9aa34b.svg";